import React from "react";

export default function Logo({ size = 44, showText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2 sm:gap-3 min-w-0 ${className}`}>
      <img
        src="/tgs-logo.png"
        alt="Takara Global Services"
        width={size}
        height={size}
        className="object-contain drop-shadow-md shrink-0"
        style={{ width: size, height: size }}
      />
      {showText && (
        <div className="leading-tight logo-text min-w-0">
          <div className="font-heading font-extrabold text-foreground text-sm sm:text-base tracking-tight truncate">
            Takara Global
          </div>
          <div className="text-[10px] sm:text-xs text-brand-gold uppercase tracking-[0.25em] font-bold">
            Services
          </div>
        </div>
      )}
    </div>
  );
}
